<template>
	<header class="header">
      <h1 class="header__title">{{ title }}</h1>
      <img src="../assets/img/logos.png" alt="" class="header__logo">
    </header>	
</template>

<script>
export default {
	name: 'header',
	props: [ 'title' ]
}	
</script>



// WEBPACK FOOTER //
// Header.vue?13989c90